export enum ModelTemplate {
  CSV = 'CSV',
  XLSX = 'XLSX',
}
